import React from 'react';

import {
  getTranslateFn,
  RequireTranslations,
  useTranslation as useTranslationHook,
} from '@project44/translations-utils';

export abstract class I18nClient {
  public abstract readonly nameSpace: string;
  public abstract readonly translations: {
    en: { [index: string]: { [index: string]: string } };
  };
  public enableI18NComponent: boolean = true;

  public readonly renderWithTranslations: React.FC = ({ children }) => {
    return this.enableI18NComponent ? (
      <RequireTranslations
        namespace={this.nameSpace}
        translations={this.translations}
        children={children}
      />
    ) : (
      <>{children}</>
    );
  };

  public static readonly useTranslation: typeof useTranslationHook = () => {
    return useTranslationHook();
  };

  public static readonly createScopedTranslator: typeof getTranslateFn = (
    args,
  ) => {
    return getTranslateFn(args);
  };
}
